import React from 'react';
import {
    useExpenseAccountIdInputQuery,
    useExpenseReceiptTypeIdInputQuery,
} from '../../../../../../../services';
import { RhSingleAutocomplete } from '../../../../../../dum';
import {
    ACCOUNT,
    IExpense,
    NON_TAX_RETAINED,
    REQUIRE_EXTERNAL_CODE,
    REQUIRE_SUPPLEMENT,
    TAX,
    TAX_RETAINED,
} from '../expense-form';
import { useFormContext } from 'react-hook-form';
import { useSetExpenseTaxRequirement } from '../use-set-expense-tax-requirement';
import { FIELD_LABELS, shortLabel } from '../../../../../../../helpers';

export function ExpenseReceiptTypeIdInput() {
    const inputName: keyof IExpense = 'receipt_type_id';
    const { data } = useExpenseReceiptTypeIdInputQuery();
    const { data: accountsData } = useExpenseAccountIdInputQuery();
    const { getValues, setValue, trigger } = useFormContext<IExpense>();
    const { setExpenseTaxRequirement } = useSetExpenseTaxRequirement();

    const receiptTypes = data?.getReceiptTypes || [];

    return (
        <RhSingleAutocomplete
            itemText={'name'}
            itemValue={'id'}
            name={inputName}
            label={shortLabel(FIELD_LABELS.receipt_type_id)}
            options={receiptTypes}
            onChange={(receiptTypeId) => {
                const receiptType = receiptTypes.find(
                    (type) => type.id === receiptTypeId,
                );
                const appliesTax = receiptType?.applies_tax ?? false;
                const formAccount = getValues(ACCOUNT) as IExpense['account'];
                // Reopened expenses carry only a reduced account shape. Resolve
                // the full supplier defaults from the picker query before
                // deriving the taxable-document settings.
                const account =
                    accountsData?.getAccounts.find(
                        (candidate) => candidate.id === formAccount?.id,
                    ) ?? formAccount;
                setValue(
                    REQUIRE_EXTERNAL_CODE,
                    appliesTax &&
                        !!account?.supplier_requires_external_code,
                    {
                        shouldDirty: true,
                        shouldValidate: true,
                    },
                );
                setExpenseTaxRequirement(
                    appliesTax && !!account?.supplier_requires_tax,
                );
                setValue(
                    REQUIRE_SUPPLEMENT,
                    appliesTax && !!account?.supplier_require_supplement,
                    {
                        shouldDirty: true,
                        shouldValidate: true,
                    },
                );
                queueMicrotask(
                    () => void trigger([TAX, TAX_RETAINED, NON_TAX_RETAINED]),
                );
            }}
        />
    );
}
